import { GLOBAL_DATETIME_FORMAT_SET, GLOBAL_INDUSTRIES_SET, GLOBAL_SET, GLOBAL_SETTINGS_SET, GLOBAL_TIMEZONES_SET } from '../action-types';
import { IGlobalState, initialGlobalState } from './global-state';

export function reducer(state: IGlobalState = initialGlobalState(), action: any): IGlobalState {
    switch (action.type) {
        case GLOBAL_SET:
            const payload = action.payload;
            return {
                ...state,
                platforms: { ...payload.platforms },
                positionColors: [...payload.position_colors],
                currencyOptions: [...payload.currency_options],
                locales: [...payload.locales]
              };

        case GLOBAL_INDUSTRIES_SET:
            return {
                ...state,
                industries: action.payload.industries,
            };

        case GLOBAL_SETTINGS_SET:
            return {
                ...state,
                settings: {
                    ...action.payload
                }
            };

        case GLOBAL_TIMEZONES_SET:
            return {
                ...state,
                timezones: action.payload.timezones
            };

        case GLOBAL_DATETIME_FORMAT_SET:
            return {
                ...state,
                datetimeFormats: action.payload.datetimeFormats
            };
        default:
            return state;
    }
}
